export default `query newGearItems {
  newGearItems {
    data {
      name
      sku
      discontinued
      hideprice
      typename
      url
      image_url
      regular_price
      special_price
      stock_status
      am_category_labels {
        label_id
        product_id
        name
        txt
        is_visible
        image
        position
        size
        style
        tooltip_settings {
          status
          color
          text_color
          text
        }
        customer_group_ids
        redirect_url
        alt_tag
      }
    }
  }
}`;